import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const RemoveIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 13H5V11H19V13Z" fill="#333333" />
      </svg>
    )
  }
)
